import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { mergePdfs } from "../helpers/pdfs";
import { addTrailingZeros } from "../helpers/common";

const generatePDF = async (purchaseData) => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.width;

    // Logo
    doc.addImage(visionLogo, "PNG", 8, 7, 44, 12);
    doc.setFontSize(16);
    doc.text("Purchase Order - Vision", 200, 12, { align: "right" })

    doc.setFillColor(248, 248, 248);
    doc.rect(0, 22, pageWidth, 12, "F");

    doc.setFontSize(12);
    doc.setTextColor("#787a80")
    doc.text(`Agent: ${purchaseData.agentCode}`, 15, 30);
    doc.text(`Date: ${moment(purchaseData.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}`, 200, 30, { align: "right" });
    doc.setTextColor("#252527");

    // Product Details Table
    const products = purchaseData?.products;

    autoTable(doc, {
        startY: 40,
        columnStyles: {
            0: { cellWidth: 100, halign: "center" },
            1: { cellWidth: 70, halign: "center" },
        },
        head: [["Products", "TTL"]],
        body: products.map((product) => {
            let ProductName = `${product.ProductName} ${product.ClassName || ''} ${product.SizeName || ''} ${product.UnitName || ''}`
            ProductName = ProductName?.replace(/\s+/g, ' ').trim();
            return ([ProductName, addTrailingZeros(product.TotalQty)])
        }),
        theme: "grid",
        headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            lineWidth: 0.2
        },
        styles: { fontSize: 10 },
        margin: { top: 8, bottom: 10, left: 20, right: 28 },
        showHead: "firstPage",
    });

    // Check End of the Page and Move to new page if there no required space left.
    let yPosition = doc.lastAutoTable.finalY + 5;
    const pageHeight = doc.internal.pageSize.height;

    if (yPosition > pageHeight) {
        doc.addPage();
        yPosition = 10;
    }

    // Footer Pagination
    const totalPageCount = doc.internal.pages.length - 1;

    for (let i = 1; i <= totalPageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor("#787a80")
        const currentDate = moment().format("DD MMMM, YYYY")
        const pageText = `Page ${i} of ${totalPageCount}`;
        const visionText = `VISION PRODUCE`;
        if (i === totalPageCount) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
            doc.line(10, doc.internal.pageSize.height - 10, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);
            doc.text(
                currentDate,
                doc.internal.pageSize.getWidth() - 200,
                doc.internal.pageSize.getHeight() - 5,
            );
            doc.text(
                visionText,
                doc.internal.pageSize.getWidth() - 110,
                doc.internal.pageSize.getHeight() - 5,
            );
        }
        doc.text(
            pageText,
            doc.internal.pageSize.getWidth() - 25,
            doc.internal.pageSize.getHeight() - 5,
        );
    }

    return doc.output("arraybuffer");
}

export const generatePurchasePdf = async (purchaseDataArray, isEmail = false) => {
    const pdfs = [];
    for (const ele of purchaseDataArray) {
        const doc = await generatePDF(ele);
        pdfs.push(doc);
    }

    const mergedPdf = await mergePdfs(pdfs);
    if (isEmail) {
        return mergedPdf;
    }
    const blob = new Blob([mergedPdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}